import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/ui-bits";

export default function Audit() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/audit").then(r => setList(r.data)); }, []);
  return (
    <div data-testid="audit-page">
      <PageHeader eyebrow="Security" title="Audit Logs" description="Every create/update/delete tracked in the system." />
      <Card padding="p-0">
        {list.length === 0 ? <div className="p-8"><Empty title="No audit events yet"/></div> : (
          <div className="overflow-x-auto">
            <table className="ddms-table"><thead><tr><th>When</th><th>User</th><th>Action</th><th>Module</th><th>Summary</th></tr></thead><tbody>
              {list.map(a => (
                <tr key={a.id}>
                  <td className="font-mono text-xs">{fmtDate(a.created_at)} {new Date(a.created_at).toLocaleTimeString()}</td>
                  <td>{a.user_name || a.user_id}</td>
                  <td><span className="px-2 py-0.5 rounded-full text-[11px] bg-cobalt-50 text-cobalt-700 font-medium">{a.action}</span></td>
                  <td>{a.module}</td>
                  <td className="text-slate-500 text-xs font-mono truncate max-w-md">{JSON.stringify(a.new_data || a.old_data || {}).slice(0, 100)}</td>
                </tr>
              ))}
            </tbody></table>
          </div>
        )}
      </Card>
    </div>
  );
}
